<template>
	<div class="patient-view response">
		<AssessmentCard :patient="patient"></AssessmentCard>
	</div>
</template>

<script>
import PatientView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'patient-assessment',
	extends: PatientView,
	computed: {
		...mapGetters(['getUserType'])
	}
}
</script>
